var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPizza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.10001L16 4L27.9 24.7C19.9 29.2 12 29.2 4 24.7L9.8 14.7",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7002 21.2002C8.77633 23.1145 12.3271 24.1291 15.9502 24.1291C19.5733 24.1291 23.1241 23.1145 26.2002 21.2002",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 20.5002C18.9493 20.5002 19.8 19.6496 19.8 18.6002C19.8 17.5509 18.9493 16.7002 17.9 16.7002C16.8507 16.7002 16 17.5509 16 18.6002C16 19.6496 16.8507 20.5002 17.9 20.5002Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0998 12.1001C15.0998 12.9753 14.7521 13.8147 14.1333 14.4335C13.5144 15.0524 12.675 15.4001 11.7998 15.4001C11.0792 15.3667 10.384 15.1234 9.7998 14.7001L12.9998 9.1001C13.5996 9.34763 14.1161 9.76162 14.4882 10.2932C14.8603 10.8248 15.0725 11.4518 15.0998 12.1001Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizza);
export default __webpack_public_path__ + "static/media/pizza.1d1428799b17baaa1f93efbcf81f7749.svg";
export { ForwardRef as ReactComponent };